export const CompanyIcon = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="11.5" fill="#fff" stroke="#CDD0D5" />
    <path
      stroke="#0A0D14"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.375 11.417H7.683c-.326 0-.49 0-.615.063a.6.6 0 0 0-.254.255c-.064.125-.064.288-.064.615v4.9m7.875-5.833h1.692c.326 0 .49 0 .614.063.11.056.2.145.255.255.064.125.064.288.064.615v4.9m-2.625 0V8.617c0-.654 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127h-1.516c-.654 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23v8.633m8.458 0H6.167m5.25-8.167h1.166m-1.166 2.334h1.166m-1.166 2.333h1.166"
    />
  </svg>
);
